<template>
    <Modal :show="showTermsModal" @close="showTermsModal = false" :closeable="false" maxWidth="sm">
        <div class="bg-white text-center  rounded p-4">
            <p>{{ $t('terms.1') }}</p>
            <div  class="text-[12px] my-4">
                <p>{{ $t('terms.modal.p1') }}</p>
                <p>{{ $t('terms.modal.p2') }}</p>
            </div>
            <div class="flex items-center gap-2 justify-center mt-6">
                <DefaultButton class="bg-neutral-600/75 text-white" @click="rejectTerms">{{ $t('terms.modal.reject') }}</DefaultButton>
                <DefaultButton  @click="acceptTerms">{{ $t('terms.modal.accept') }}</DefaultButton>
            </div>
        </div>
    </Modal>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { useAuthStore } from '@/stores/auth';
  import Modal from '@/components/Modal.vue';
  import DefaultButton from '@/components/Buttons/DefaultButton.vue';
  
  const auth = useAuthStore();
  const showTermsModal = ref(false);

  const rejectTerms = ()=>{
    auth.logout()
  }
  const acceptTerms = async () => {
    const res = await auth.acceptTerms();
    if (res && res.status === 204) {
        showTermsModal.value = false;
    }
    }
  defineExpose({
    openModal: () => {
        showTermsModal.value = true;
    }
  });
  </script>